import React from "react";
import "./styles.scss";
export var ProgressIndicator = function (_a) {
    var displayPage = _a.displayPage;
    return (React.createElement("div", { className: "progress-container" }));
};
